import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { QcMerchantResponse } from 'src/app/shared/models/qcResponse.model';

export const CompanyLogoURLChanged = createAction(
  '[Merchant: General]: Company Logo URL Changed',
  props<{ merchantLogoUrl: string | ArrayBuffer | null }>(),
);

export const CompanyLogoUpdateSuccess = createAction(
  '[Merchant: General]: Company Logo Update Success',
  props<{ res: QcMerchantResponse }>(),
);

export const CompanyLogoUpdateFailed = createAction(
  '[Merchant: General]: Company Logo Update Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const FirstNameChanged = createAction(
  '[Merchant: General]: First Name Changed',
  props<{ firstName: string }>(),
);

export const LastNameChanged = createAction(
  '[Merchant: General]: Last Name Changed',
  props<{ lastName: string }>(),
);

export const VATChanged = createAction(
  '[Merchant: General]: VAT Changed',
  props<{ vatNumber: string }>(),
);

export const UpdateMerchant = createAction('[Merchant: General]: Update Merchant');

export const UpdateMerchantSuccess = createAction('[Merchant: General]: Update Merchant Success');

export const UpdateMerchantFailed = createAction('[Merchant: General]: Update Merchant Failed');

export const HasLoyaltyFlagChanged = createAction(
  '[Merchant: General]: Has LoyaltyFlag Changed',
  props<{ hasLoyaltyFlag: boolean }>(),
);

export const SelectedSchemaChanged = createAction(
  '[Merchant: General]: Selected Schema Changed',
  props<{ selectedSchema: string }>(),
);

export const MerchantNameChanged = createAction(
  '[Merchant: General]: Merchant Name Changed',
  props<{ companyName: string }>(),
);

export const WebsiteURLChanged = createAction(
  '[Merchant: General]: Website URL Changed',
  props<{ websiteURL: string }>(),
);

export const EmailChanged = createAction(
  '[Merchant: General]: Email Changed',
  props<{ email: string }>(),
);
